<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<blockquote>
<p class="para"><a id="page_13"></a>We were born to unite with our fellow-men and to join in community with the human race.</p>
<p class="right-paraa"><strong>CICERO:</strong> <em>De finibus,</em> IV</p>
<p class="para"> </p>
<p class="para">Of all animals, men are the least fitted to live in herds. If they were crowded together as sheep are they would all perish in a short time. The breath of man is fatal to his fellows.</p>
<p class="right-paraa"><strong>JEAN-JACQUES ROUSSEAU:</strong> <em>Emile,</em> I</p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmattera.vue?4b9b622a